import React from 'react'
import { Grid, Typography, Button } from '@material-ui/core'
import ModalComponent from 'Components/Modal/Modal.component'

interface Props {
  classes: any,
  open: boolean,
  onClose(): void,
}

const ExtraInfoModal = (props: Props) => {
  const {
    classes,
    open,
    onClose,
  } = props
  return (
    <ModalComponent
      content={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant='body2'>
              App notifications will appear in Boral Connects via the bell button, on the homepage or as dismissible banners.
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant='body2'>SMS notifications will be sent to the mobile number entered on your Boral Connects user profile.</Typography>
          </Grid>
        </Grid>
      }
      footer={
        <Grid className={classes.textAlignRight} container justify='flex-end' spacing={2}>
          <Grid item>
            <Button className={classes.button} color='primary' onClick={onClose} variant='contained'>
              OK
            </Button>
          </Grid>
        </Grid>
      }
      paperClasses={classes.paperClasses}
      maxWidth='sm'
      icon={null}
      preventFullScreen
      onClose={onClose}
      open={open}
      rightHeading={null}
      title={`App & SMS Notifications`}
    />
  )
}


export default ExtraInfoModal
